

// export default function AgendamientoNocPage() {
//   return (
//     <div>AgendamientoNocPage</div>
//   )
// }


import { Tab } from '@mui/material';

// import {
//   PreagendamientoPendientePage,
//   // PreagendamientosByStatePage,
//   // PreagendasActualizadasPyL,
// } from '@/erp/operaciones/preagendamiento/pages/tables';
import {
  EstadosAgendamientoEnumChoice,
  // EstadosOrdenTrabajoEnumChoice,
  // ROUTER_PATHS,
  // EstadosPreagendamientoEnumChoice,
  a11yProps,
  // hasPermission,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import PreagendamientoPendientePageEstadoAceptacion from '../tables/PreagendamientoPendientePageEstadoAceptacion';
import AgendaAprobadosCorporativoPage from '../tables/AgendaAprobadosCorporativoPage';

export type AgendamientoNocPageProps = {};

const AgendamientoNocPage: React.FC<AgendamientoNocPageProps> = () => {
  const { handleMethodChange, valueTab } = useTabsFormOnly({});
  useCheckPermissions(PermissionsEnum.api_view_agendacorporativa)

  return (
    <SingleTableBoxScene title={'Agendamientos NOC'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Factibilidad" value={1} {...a11yProps(1)} />
          <Tab label="Agendadas" value={2} {...a11yProps(2)} />
          <Tab label="Recoordinadas" value={3} {...a11yProps(3)} />

        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Preagendamientos ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <PreagendamientoPendientePageEstadoAceptacion />
      </CustomTabPanel>


      {/* ============ Agendadas - Agenda ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <AgendaAprobadosCorporativoPage
          stateAgendamiento={EstadosAgendamientoEnumChoice.APROBADO}
        />
      </CustomTabPanel>

      {/* ============ Recoordinadas Espera - Agenda ============ */}
      <CustomTabPanel value={valueTab} index={3}>
      <AgendaAprobadosCorporativoPage
          stateAgendamiento={EstadosAgendamientoEnumChoice.RECORDINADO}
        />
      </CustomTabPanel>





    </SingleTableBoxScene>

  );
};

export default AgendamientoNocPage;

